import { gql } from '@apollo/client'

export default gql`
  query mortgageWidgetPrefillSubmission(
    $loanType: WidgetLoanTypeEnum
    $vertical: MortgageSubmissionVerticalEnum
    $zipCode: String
    $productTypes: [MortgageWidgetProductTypeEnum!]
    $lenderCentricProducts: Boolean
    $bestProduct: Boolean
    $loanTypes: [WidgetLoanTypeEnum!]
    $sortingField: MortgagesMortgageSortingTypeEnum # required for lender centric products
  ) {
    mortgageWidgetPrefillSubmission(
      loanType: $loanType
      vertical: $vertical
      zipCode: $zipCode
      lenderCentricProducts: $lenderCentricProducts
      sortingField: $sortingField
    ) {
      uuid
      ficoType
      vertical
      zipCode
      loanType
      estimatedValue
      status
      downPayment
      homeValue
      loanAmount
      occupancyType
      propertyType
      cashOut
      products(productTypes: $productTypes, bestProduct: $bestProduct, loanTypes: $loanTypes) {
        closingCost
        discount
        uuid
        externalProductId
        lender {
          name
          nmls
          slug
          purchaseRating
        }
        monthlyPayment
        loanTerm
        loanType
        amortizationType
        productType
        rate
        apr
        fees
        bestProduct
      }
    }
  }
`
